import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { CacheDataSource } from "./cache.datasource";
import { ENVIRONMENT } from "../../core/token";

@Injectable()
export class UsersDataSource extends CacheDataSource {
	constructor(@Inject(ENVIRONMENT) protected environment, httpClient: HttpClient) {
		super(httpClient);
		this.setPath(environment.api_url + "/v2/members");
	}

	public getUserNames(assignedUsers: Array<{ userId: string }>): Observable<any> {
		let query = "";

		const filtered = assignedUsers.filter((el) => el.userId !== undefined && this.get(el.userId) === undefined);

		if (filtered.length === 0) {
			const users = assignedUsers.map((el) => this.get(el.userId));
			return of(users.map((user: any) => user["username"]));
		}

		filtered.forEach((assignedUser, index) => {
			let pre = "&";
			if (index == 0) {
				pre = "?";
			}
			query += pre + "_id=" + assignedUser.userId;
		});

		this.setQuery(query);

		const obs = this.getDataAsObservable().pipe(
			map((result) => {
				result.data.forEach((element: any) => {
					this.set(element._id, element);
				});
				const users: any[] = [];
				assignedUsers.forEach((assignedUser) => {
					const requestUser: any = this.get(assignedUser.userId);
					if (requestUser) {
						users.push(requestUser["username"]);
					}
				});

				return users;
			}),
			shareReplay(1),
		);

		this.setQuery("");

		return obs;
	}
}
